/* ============================================================================
   gs-gift.js — grow-some
   Path: assets/gs-gift.js

   Auto-add / auto-remove a free gift line based on the cart subtotal.

   Pairs with a Shopify Admin AUTOMATIC "Buy X Get Y (Free)" discount that makes
   the gift free once the cart qualifies (min purchase amount). Shopify does NOT
   auto-add the Y product to the cart — this script does that: it keeps the gift
   line present (qty 1) while the NON-gift subtotal >= threshold, and removes it
   when it drops below. If the customer ends up below the threshold at checkout,
   Shopify re-evaluates the discount server-side, so abuse is not possible.

   Config comes from window.GS_GIFT (emitted by sections/cart-drawer.liquid):
     { variantId: "<gift variant id>", thresholdCents: <int> }
   The thresholdCents MUST match the bar threshold (Ціль 2) and the Admin
   discount's minimum purchase amount.

   Depends on theme globals (loaded before this file): routes, fetchConfig,
   subscribe, publish, PUB_SUB_EVENTS. Bails out quietly if any is missing.
   ============================================================================ */
(function () {
  'use strict';

  var cfg = window.GS_GIFT;
  if (!cfg || !cfg.variantId || !cfg.thresholdCents) return;

  var GIFT_ID   = parseInt(cfg.variantId, 10);
  var THRESHOLD = parseInt(cfg.thresholdCents, 10);
  if (!GIFT_ID || !THRESHOLD) return;

  if (typeof subscribe !== 'function' || typeof publish !== 'function' ||
      typeof PUB_SUB_EVENTS === 'undefined' || typeof routes === 'undefined') return;

  var SOURCE = 'gs-gift';
  var busy = false;

  function giftLine(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === GIFT_ID) return items[i];
    }
    return null;
  }

  // Sum of every line EXCEPT the gift itself (so adding the gift never affects
  // whether the cart still qualifies — no oscillation).
  function nonGiftCents(cart) {
    var items = (cart && cart.items) || [];
    var sum = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id !== GIFT_ID) sum += items[i].final_line_price;
    }
    return sum;
  }

  function getCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addGift() {
    var body = JSON.stringify({ items: [{ id: GIFT_ID, quantity: 1 }] });
    return fetch(routes.cart_add_url, Object.assign({}, fetchConfig(), { body: body }));
  }

  function changeGift(key, qty) {
    var body = JSON.stringify({ id: key, quantity: qty });
    return fetch(routes.cart_change_url, Object.assign({}, fetchConfig(), { body: body }));
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var gift = giftLine(cart);
      var qualifies = nonGiftCents(cart) >= THRESHOLD;
      var action = null;

      if (qualifies && !gift)               action = addGift();
      else if (!qualifies && gift)          action = changeGift(gift.key, 0);
      else if (gift && gift.quantity !== 1) action = changeGift(gift.key, 1);

      if (!action) { busy = false; return; }

      action
        .then(function () { return getCart(); })
        .then(function (fresh) {
          busy = false;
          // Let the theme re-render drawer / cart / bubble. Our own subscriber
          // ignores SOURCE, so this does not loop back into reconcile().
          publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: fresh });
        })
        .catch(function () { busy = false; });
    }).catch(function () { busy = false; });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event && event.source === SOURCE) return;
    reconcile();
  });

  // Initial pass: a restored session may already qualify without the gift.
  if (document.readyState !== 'loading') reconcile();
  else document.addEventListener('DOMContentLoaded', reconcile);
})();
